import { Directive, ElementRef } from '@angular/core';

import { ElementProvider } from '@frontend/sports/common/core/utils/element-provider';

import { MODAL_DIALOG_CONTAINER } from './modal-dialog.model';

@Directive({
    selector: '[msModalDialogContainer]',
    providers: [
        { provide: MODAL_DIALOG_CONTAINER, deps: [ElementRef], useFactory: (element: ElementRef<HTMLElement>) => new ElementProvider(element) },
    ],
})
export class ModalDialogContainerDirective {}
